<template>
  <div class="moduleTitle">
    <p>{{title}}</p>
    <!-- <div></div> -->
  </div>
</template>

<script>
export default {
  name: "moduleTitle",
  props: {
    title: String,
  },
  methods: {},
  data() {
    return {};
  },
};
</script>

<style>
.moduleTitle {
  width: 100%;
  text-align: left;
  margin-top: 20px;
  margin-bottom: 20px;
}
.moduleTitle p {
  display: inline-block;
  font-size: 32px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #181818;
  border-bottom: 6px solid rgba(10, 177, 255, 1);
}
/* .moduleTitle div {
  width: 126px;
  height: 6px;
  margin-top: 10px;
  background-color: rgba(10, 177, 255, 1);
} */
</style>


// WEBPACK FOOTER //
// src/components/component/moduleTitle.vue